export const API_V1_URI = "/api/v1";

export const ACCOUNT_API_REFRESH_TOKEN = API_V1_URI + "/accounts/refresh-token";

export const SALON_SERVICE_API = API_V1_URI + "/client/salon_services";

export const SALON_SERVICE_CATEGORY_API =
  API_V1_URI + "/client/salon_service_categories";

export const BRANCH_API = API_V1_URI + "/client/branches";

export const SALON_STAFF_API = API_V1_URI + "/client/salon_staffs";
export const SALON_STAFF_API_SEARCH = SALON_STAFF_API + "/search";

export const APPOINTMENT_API = API_V1_URI + "/client/appointments";
export const APPOINTMENT_API_GET_HOUR_LIST = APPOINTMENT_API + "/get_hour_list";
